import { createSlice } from "@reduxjs/toolkit";
import { homepageApiSlice } from "./api";

export const initialState = {
  query: {},
  selectedProductDetails: {
    productDetails: {},
    schemeDetails: {},
    one: {
      variant_id: {},
    },
    variantTest: {},
    availableVariantsKeys: {},
    is_available_to_buy: false,
  },
  officeOptions: [],
  openOrderSucc: false,
  orderConfirmedData: {},
  districtOptions: [],
  vdcsOptions: [],
};

const homepageSlice = createSlice({
  name: "homepage",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    clearOne: (state, action) => {
      state.selectedProductDetails = initialState.selectedProductDetails;
    },
    setSelectedProduct: (state, { payload }) => {
      state.selectedProductDetails.productDetails = payload;
      if (payload?.is_multiple_variation) {
        state.selectedProductDetails.variantTest =
          payload.inventory_type?.reduce(
            (acc, curr) => ({
              ...acc,
              [curr.inventory_type]: curr.option[0],
            }),
            {}
          ) || {};
      }
      state.selectedProductDetails.schemeDetails = {};
      const reqVariantObj = payload?.variant?.[0];
      state.selectedProductDetails.one.variant_id = reqVariantObj;

      // check if the product is valid to buy
      if (reqVariantObj?.is_available) {
        if (reqVariantObj?.inventory <= 0) {
          state.selectedProductDetails.is_available_to_buy = false;
        } else {
          state.selectedProductDetails.is_available_to_buy = true;
        }
      } else {
        state.selectedProductDetails.is_available_to_buy = false;
      }
    },
    setSelectedScheme: (state, { payload }) => {
      state.selectedProductDetails.schemeDetails = payload;
    },
    setCustomerValues: (state, { payload }) => {
      state.selectedProductDetails.customerDetails[payload.key] = payload.value;
    },
    setSelectVarirant: (state, { payload }) => {
      state.selectedProductDetails.variantTest[payload.inventory_type] =
        payload.inventory_value;
      let newVariantTestObj = {
        ...state.selectedProductDetails.variantTest,
        [payload.inventory_type]: payload.inventory_value,
      };
      let requiredSku = Object.values(newVariantTestObj).join("-");
      const reqVariantObj =
        state.selectedProductDetails.productDetails?.variant?.find(
          (x) => x.sku_of_seller === requiredSku
        );
      state.selectedProductDetails.one.variant_id = reqVariantObj;
      // check if the product is valid to buy
      if (reqVariantObj?.is_available) {
        if (reqVariantObj?.inventory <= 0) {
          state.selectedProductDetails.is_available_to_buy = false;
        } else {
          state.selectedProductDetails.is_available_to_buy = true;
        }
      } else {
        state.selectedProductDetails.is_available_to_buy = false;
      }
    },
    setOpenOrderSucc: (state, { payload }) => {
      state.openOrderSucc = payload;
    },
    setOrderConfimredData: (state, { payload }) => {
      state.orderConfirmedData = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        homepageApiSlice.endpoints.loadPublicSchemeDetails.matchFulfilled,
        (state, { payload }) => {
          if (payload.data) {
            state.selectedProductDetails.schemeDetails = payload.data;
            const reqVariantObj = payload.data.main_product?.variant?.[0];
            state.selectedProductDetails.one.variant_id = reqVariantObj;

            // check if the product is valid to buy
            if (reqVariantObj?.is_available) {
              if (reqVariantObj?.inventory <= 0) {
                state.selectedProductDetails.is_available_to_buy = false;
              }
              state.selectedProductDetails.is_available_to_buy = true;
            } else {
              state.selectedProductDetails.is_available_to_buy = false;
            }

            if (payload.data?.main_product?.is_multiple_variation) {
              state.selectedProductDetails.variantTest =
                payload.data?.main_product?.inventory_type?.reduce(
                  (acc, curr) => ({
                    ...acc,
                    [curr.inventory_type]: curr.option[0],
                  }),
                  {}
                ) || {};
            }
          }
        }
      )
      .addMatcher(
        homepageApiSlice.endpoints.loadPublicOfficeOptions.matchFulfilled,
        (state, { payload }) => {
          state.officeOptions = payload.data.map((x) => ({
            label: x.name,
            value: x._id,
          }));
        }
      )
      .addMatcher(
        homepageApiSlice.endpoints.placeOrderPublicScheme.matchFulfilled,
        (state) => {
          state.openOrderSucc = true;
          state.selectedProductDetails = initialState.selectedProductDetails;
        }
      )
      .addMatcher(
        homepageApiSlice.endpoints.loadAvailableDistrictForUser.matchFulfilled,
        (state, { payload }) => {
          state.districtOptions = payload.data.map((each) => ({
            label: each.name,
            value: each._id,
          }));
        }
      )
      .addMatcher(
        homepageApiSlice.endpoints.loadAvailableVDCForUser.matchFulfilled,
        (state, { payload }) => {
          state.vdcsOptions = payload.data.map((each) => ({
            label: each.name,
            value: each._id,
          }));
        }
      );
  },
});

export const {
  setQueryValue,
  setOneValue,
  clearOne,
  setCustomerValues,
  setSelectedProduct,
  setSelectedScheme,
  setSelectVarirant,
  setOpenOrderSucc,
  setOrderConfimredData,
} = homepageSlice.actions;

export default homepageSlice.reducer;
